<template>
    <div>
         <div class="chat-bot-wrapper">
             <div class="chat-bot-wrapper-inner">
             </div>
             <div class="conversation-wrapper" ref="conversation-wrapper">
                 <div class="message-wrapper" v-for="message in messages" :key="message.id">
                     <div class="message-content" :class="message.type" style="white-space: pre-line" ><span v-html="message.text"></span></div>
                 </div>
                 <div class="message-content loader" v-if="loading"><div id="wave">
                        <span class="dot"></span>
                        <span class="dot"></span>
                        <span class="dot"></span>
                    </div>
                </div>
                <div ref="bottomEl"></div>
             </div>
             <div class="input-wrapper">
                 <form @submit.prevent="sendMessage">
                     <el-input type="text" class="input-field question-input" placeholder="Type your message here..." v-model="question"/>
                     <el-button class="search-btn">
                        {{ $trans('web_search.start_search') }}
                    </el-button>
                 </form>
             </div>
         </div>
    </div>
 </template>
 
 <script>
 import axios from 'axios';
 
 export default {
     data() {
         return {
             messages: [],
             question: '',
             loading: false,
             thread_id: null,
             run_id: null,
             loading: false,
         }
     },
     created() {
       
         let token = document.head.querySelector('meta[name="csrf-token"]');
         
 
         axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
         if (token) {
             axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
         } else {
             console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
         }
     },
     methods: {
         async sendMessage() {
             this.loading = true;
             this.messages.push({
                 text: this.question,
                 sender: 'user',
                 type: 'send'
             });

             try {
                  const response = await axios.post('/ai/response', {
                      'question': this.question,
                      'thread_id': this.thread_id,
                      'run_id': this.run_id,
                  })
                  this.loading = false;
                  this.thread_id = response.data.thread_id;
                  this.run_id = response.data.run_id;
                  this.messages.push({
                      text: response.data.assistant_message,
                      sender: 'ai',
                      type: 'response'
                  });
                this.question = '';

                const lastChildElement =
                    this.$refs.conversation-wrapper.lastElementChild;
                lastChildElement?.scrollIntoView({
                    behavior: 'smooth',
                });

              } catch (error) {
                  console.error(error);
              }
             this.loading = false;
         }
     }
 }
 </script>
 <style lang="css" scoped>
 .chat-bot-wrapper {
    width: 800px;
 }
 .input-wrapper {
    padding: 10px;
 }
 .message-content {
    border: 1px solid #909399;
    border-radius: 5px;
    padding: 10px;
    margin: 10px;
    width: 50%;
 }
 .message-content.send {
    background-color: #41ABC4;
    float: left;
 }

 .message-content.response {
    background-color: #eee;
    float: right;
}
.conversation-wrapper  {
    display: flex;
    flex-direction: column;
    max-height: 500px;
    overflow: scroll;
}
.search-btn {
    margin-left: 15px;
    border-radius: 24px;
    padding-left: 30px;
    padding-right: 30px;
    background-color: #41ABC4;
    color: #fff;
}
.question-input  {
    border: 1px solid #909399;
}
.loader {
    font-size: 24px;
    float:right;
    padding: 10px;
    margin: 10px;
    border: 0px!important;
    width: 100%!important;
}

div#wave {
	text-align:center;
    float:right;
	.dot {
		display:inline-block;
		width:12px;
		height:12px;
		border-radius:50%;
		margin-right:3px;
		background:#909399;
		animation: wave 1.3s linear infinite;

		&:nth-child(2) {
			animation-delay: -1.1s;
		}

		&:nth-child(3) {
			animation-delay: -0.9s;
		}
	}
}

@keyframes wave {
	0%, 60%, 100% {
		transform: initial;
	}

	30% {
		transform: translateY(-15px);
	}
}
 </style>